import { PathOptions } from "leaflet";
import {
  DGC_REFERENCE_YEAR,
  getDgcColor,
} from "../constants/dgcConjuntos";

/**
 * Conjuntos elétricos coloridos pelo DGC do ano de referência.
 * Espelha o SLD `neoenergia_pe_conj_dgc` publicado no GeoServer.
 */
export const neoenergia_pe_conj_dgc = (feature: any): PathOptions => {
  const dgc = feature?.properties?.[`DGC_${DGC_REFERENCE_YEAR}`];

  return {
    fillColor: getDgcColor(dgc),
    color: "#404040",
    weight: 1,
    fillOpacity: 0.75,
  };
};
